import { useMatch, useResolvedPath } from "react-router-dom";

function useRouteMatch() {
  const resolvedPath = useResolvedPath("");
  return useMatch(`${resolvedPath.pathname}/:name`);
}

export { useRouteMatch };
